//import axios from "axios";
import ApiService from "@/core/services/api.service";
// action types
export const OBTENER_RESPUESTAS = "obtenerRespuestas";
export const OBTENER_RESPUESTA = "obtenerRespuesta";
export const REGISTRAR_RESPUESTA = "registrarRespuesta";
export const ACTUALIZAR_RESPUESTA = "actualizarRespuesta";

export const OBTENER_RESPUESTAS_PREGUNTA_TIPODATO = "obtenerRespuestasPorPreguntaTipoDato";
// mutation types
export const SET_RESPUESTAS = "setRespuestas";
export const SET_RESPUESTA = "setRespuesta";

const state = {
    respuestas:[],
    respuesta:[],
    data: [
        {id:1, textoRespuesta: 'Hombres', estadosId: 1, estado: 'Activo', indicesId: 1, preguntasId: 1}, 
        {id:2, textoRespuesta: 'Mujeres', estadosId: 1, estado: 'Activo', indicesId: 1, preguntasId: 1},
        {id:3, textoRespuesta: 'Segundo Nivel', estadosId: 1, estado: 'Activo', indicesId: 1, preguntasId: 2},
        {id:4, textoRespuesta: '¿Cuenta con reglamento aprobado?', estadosId: 1, estado: 'Activo', indicesId: 1, preguntasId: 2},
        {id:5, textoRespuesta: '¿Cuántos síndicos y concejales están registrados?', estadosId: 2, estado: 'Inactivo', indicesId: 1, preguntasId: 2},
        {id:6, textoRespuesta: '¿Cuantas reuniones ha realizado durante este periodo?', estadosId: 1, estado: 'Activo', indicesId: 2, preguntasId: 2}],
    
}

const getters = {
    obtenerrespuestas(state) {
      return state.respuestas;
    },
}

const actions = {
    async [OBTENER_RESPUESTAS](context, datos) {
        
        let endpoint = `api/Respuesta/Pregunta/all/${datos.preguntasId}`
        if(datos.estadoId){
            endpoint = `api/Respuesta/Pregunta/Estado/${datos.estadoId}/${datos.preguntasId}`
        }
        return new Promise(resolve => {
            ApiService.query(`apiconsume/obtener?endpoint=${endpoint}`, '')
                .then(({ data }) => {
                    context.commit(SET_RESPUESTAS, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                });
        });   
    
    },

    async [OBTENER_RESPUESTA](context, id){
        return new Promise(resolve => {
            ApiService.query(`apiconsume/edit/${id}?endpoint=api/Respuestas/`)
                .then(({ data }) => {
                    context.commit(SET_RESPUESTA,data.data);
                    //console.log(this.instituciones)
                    resolve(data)
                })
                .catch((error) => {
                    
                    resolve(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });   
    },

    async [REGISTRAR_RESPUESTA](context, datos){
        return new Promise(resolve => {
            ApiService.post(`apiconsume/create?endpoint=api/Respuestas`, datos)
                .then(({ data }) => {
                    if(data.status===200){
                        context.commit(SET_RESPUESTA, data.data);
                    }
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                });
        });   
    },

    async [ACTUALIZAR_RESPUESTA](context, datos){
        let id = datos.id;
        
        return new Promise(resolve => {
            ApiService.post(`apiconsume/update/${id}?endpoint=api/Respuestas/`, datos)
                .then(({ data }) => {
                    context.commit(SET_RESPUESTA, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });    
    },

    async [OBTENER_RESPUESTAS_PREGUNTA_TIPODATO](context, datos) {
        
        let endpoint = `api/Respuesta/Pregunta/TipoDato/all/${datos.preguntasId}/${datos.tipoDatoId}`
        
        return new Promise(resolve => {
            ApiService.query(`apiconsume/obtener?endpoint=${endpoint}`, '')
                .then(({ data }) => {
                    context.commit(SET_RESPUESTAS, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                });
        });   
    
    },

}

const mutations = {
    [SET_RESPUESTAS](state, data) {
        state.respuestas = data;
    },

    [SET_RESPUESTA](state, data) {
        state.respuesta = data;
    }
}


export default {
    state,
    getters,
    actions,
    mutations
}